// 一次性迁移：将默认语言强制重置为英文（仅执行一次，保留用户后续手动切换）
(function resetDefaultLangOnce() {
  const MIGRATION_KEY = 'lhkdLangResetToEn_v1'
  if (!window.localStorage.getItem(MIGRATION_KEY)) {
    window.localStorage.setItem('lhkdLang', 'en')
    window.localStorage.setItem(MIGRATION_KEY, '1')
  }
})()

import CustomPagization from '@/components/CustomPagization';
import ElementUI from 'element-ui';

import Vue from 'vue';
import App from './App.vue';

import './router/permission'; // 权限
import router from './router';
import store from './store';
import 'element-ui/lib/theme-chalk/index.css';
// import VueBarcode from "vue-barcode";
import htmlToPdf from './utils/htmlToPdf.js'
import i18n from  './lang/index.js'
// 注册公共组件
Vue.component('CustomPagization', CustomPagization);
// Vue.component('barcode', VueBarcode);
Vue.config.productionTip = false;
// Vue.use(ElementUI);
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(htmlToPdf)
new Vue({
  router,
  store,
  i18n,
  render(h) { return h(App); },
}).$mount('#app');
